import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {DayService, DragAndDropService, EventSettingsModel, GroupModel, MonthService, PopupCloseEventArgs, PopupOpenEventArgs, RecurrenceEditor, ResizeService, ScheduleComponent, TimelineViewsService, Timezone, WeekService, WorkWeekService,} from '@syncfusion/ej2-angular-schedule';
import {LocalStorageService} from 'src/app/local-storage.service';
import {MainDataModels} from 'src/app/models/maindata-models';
import {DatumFormatPipe} from 'src/app/pipes/datum-format.pipe';
import {MainDataService} from 'src/app/services/main-data.service';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {v4 as uuidv4} from 'uuid';
import {TerminEintragComponent} from '../../pendenzen/termin-eintrag/termin-eintrag.component';
import {SpeedDialItemEventArgs} from '@syncfusion/ej2-angular-buttons';
import {Router} from '@angular/router';
import {UserAuthenticationService} from '../../../services/user-authentication.service';

@Component({
  selector: 'app-termin-mobile',
  templateUrl: './termin-mobile.component.html',
  styleUrls: ['./termin-mobile.component.scss'],
  providers: [MonthService, DayService, WeekService, WorkWeekService, ResizeService, DragAndDropService, TimelineViewsService,],
  encapsulation: ViewEncapsulation.None,
})
export class TerminMobileComponent implements OnInit {
  public dateFormat = 'dd.MM.yyyy';
  public timeFormat = 'HH:mm';

  public eventSettings: EventSettingsModel = {
    allowDeleting: false, dataSource: undefined,
  };
  public flag = false;
  public group: GroupModel = {
    resources: [],
  };
  public mitarbeiterDataSource: object[] = [];
  public allowMultipleOwner = true;
  public selectedDate: Date = new Date();
  public dayStartTime = '07:00';
  public dayEndTime = '20:00';
  public showWeekend = false;
  public showQuickInfo = false;
  @ViewChild('scheduleObj') public scheduleObj?: ScheduleComponent;
  /* Ende Mitarbeiterauswahl in Kalender */
  menuItems: any[] = [];
  private storageWebMain = 'SwissWebMainDB';
  /* Terminserien Ende */
  private myDataSource: object[] = [];
  private kalenderData?: MainDataModels.KalenderDaten;
  private currTermin?: MainDataModels.Termin;
  private dataForCalendarAppointment?: MainDataModels.TerminMitBenutzer;
  private currTerminMitBenutzern?: MainDataModels.TerminMitBenutzer;
  /* Mitarbeiterauswahl in Kalender */
  private dbMitarbeiter?: MainDataModels.Mitarbeiter[];
  private selectedMitarbeiter: string[] = [];
  private pastelTones: string[] = ['#957DAD', // Lavendel violett
    '#FEC8D8', // Helleres Violett
    '#C1E7E3', // türkis
    '#A0DB9E', // grün
    '#B3CBE3', // blau
  ];
  /* Terminserien Start */
  private recurrenceEditor: RecurrenceEditor;
  private timezone: Timezone;
  private rasterStartTime = '05:00';
  private rasterEndTime = '22:00';
  // Angeklickte Elemente speichern
  private lastClickedAppointment: any;
  private currClickedAppointment: any;
  private currClickedAppointmentEvent: any;
  // Termin-Verschiebung
  private terminAfter?: MainDataModels.TerminVerschiebung;

  constructor(private swissSettings: SwissSettingsService, private localStorageService: LocalStorageService, // private pendenzenComp: PendenzenComponent,
              public dialog: MatDialog, private userAuthService: UserAuthenticationService, private svcMessageBox: MessageBoxService, private _datumFormatPipe: DatumFormatPipe, private svcMainData: MainDataService, private router: Router) {
    // Terminserien
    this.timezone = new Timezone();
    this.recurrenceEditor = new RecurrenceEditor();
  }

  ngAfterViewInit(): void {
    this.scheduleObj!.eventSettings.dataSource = this.myDataSource;
    this.scheduleObj!.resources = this.mitarbeiterDataSource;

    if (this.scheduleObj) {
      // Steuert die weisse Fläche für die Termine
      this.scheduleObj.workHours.start = this.dayStartTime;
      this.scheduleObj.workHours.end = this.dayEndTime;

      // Steuert die graue Fläche für Termine
      this.scheduleObj.views.forEach((view: any) => {
        view.startHour = this.rasterStartTime;
        view.endHour = this.rasterEndTime;
      });

      // Ressourcen (Mitarbeiter) laden
      this.svcMainData.loadSelectedAgendaMitarbeiter().then((res) => {
        this.selectedMitarbeiter = res;
        this.loadMitarbeiter();
        this.loadPendenzen();
      });
    }
  }

  ngOnInit(): void {
    // Hier wird dem MainData-Service mitgeteilt, dass er diese Funktion dieser Instanz aufrufen kann.
    this.svcMainData.registerTerminFunc(this.loadPendenzen.bind(this));
    this.dayStartTime = this.swissSettings.getTimeGridWorkDayStart();
    this.dayEndTime = this.swissSettings.getTimeGridWorkDayEnd();
    this.rasterStartTime = this.swissSettings.getTimeGridStart();
    this.rasterEndTime = this.swissSettings.getTimeGridEnd();

    // Mitarbeiter laden
    this.svcMainData.getMitarbeiterWithDB().then((res) => {
      this.dbMitarbeiter = res.sort((a, b) => (a.loginname.toLocaleLowerCase() > b.loginname.toLocaleLowerCase() && 1) || -1);
    });
  }

  public speedMenuClicked(args: SpeedDialItemEventArgs): void {
    switch (args.item.id) {
      case (args.item.id = 'dashboard'):
        this.router.navigateByUrl('/dashboard-mobile');
        break;
      case (args.item.id = 'log.out'):
        this.userAuthService.logoutUser('/login');
        break;

      default:
        return;
    }
  }

  public speedMenuCreated(): void {
    this.menuItems = [];
    this.menuItems.push({text: 'Dashboard', id: 'dashboard'});
    this.menuItems.push({text: 'Abmelden', id: 'log.out'});
  }

  onDragStopEvent(args: any) {
    this.terminAfter = {
      Id: args.data.Id,
      startDate: this._datumFormatPipe.removeTimeFromDate(args.data.StartTime),
      startTime: this._datumFormatPipe.transformOnlyTime(args.data.StartTime),
      endDate: this._datumFormatPipe.removeTimeFromDate(args.data.EndTime),
      endTime: this._datumFormatPipe.transformOnlyTime(args.data.EndTime),
    };
    if (this.swissSettings.getWebConfig().debugMode) {
      console.log('terminAfter', this.terminAfter);
    }

    // Termin muss sofort aktualisiert werden in den Pendenzen (Navi)
    this.updateTermin();
  }

  onPopupClose(args: PopupCloseEventArgs) {
    if (args.type === 'Editor') {
      if (['Add', 'Save', 'EditSeries', 'EditOccurrence'].indexOf(this.scheduleObj!.currentAction) > -1) {
        // Handle the code if "save" button is clicked.
        if (this.swissSettings.getWebConfig().debugMode) {
          console.log('onPopupClose', args);
        }
      }
    }
  }

  onPopupOpen(args: PopupOpenEventArgs) {
    if (this.swissSettings.getWebConfig().debugMode) {
      console.log('onPopupOpen:', args);
    }
    args.cancel = true; // Standard-Dialog ausblenden
    if (args.data?.Id) {
      this.onEditTermin();
    } else {
      this.onNewTermin();
    }
  }

  onEventClick(args: any): void {
    if (args.event.Id) {
      // Aktuelles Termin-Objekt ermitteln
      this.currTermin = this.kalenderData?.termine?.filter((x) => x.id == args.event.Id)[0];
      if (this.swissSettings.getWebConfig().debugMode) {
        console.log('currTermin', this.currTermin);
      }

      // Termin für das "Wieder-Laden" beim App-Start in IndexedDB speichern
      this.svcMainData.saveChoosedAppointmentToDB(this.currTermin!.id);

      // Termin gründ einfärben
      if (this.currClickedAppointment) {
        this.lastClickedAppointment = this.currClickedAppointment;
      }

      this.currClickedAppointment = args.element;
      this.currClickedAppointmentEvent = args.event;
      if (this.currClickedAppointment) {
        if (this.swissSettings.getWebConfig().debugMode) {
          console.log('Selected Element:', this.currClickedAppointment);
        }
        args.element.style.backgroundColor = 'Green';
        if (this.lastClickedAppointment) {
          // Zuletzt angeklickten Termin nicht mehr Grün entfernen
          this.lastClickedAppointment.style.backgroundColor = null;
        }
      }

      if (this.currTermin) {
        try {
          this.svcMainData.setTermin(this.currTermin);
          // this.pendenzenComp.reloadAppointment(this.currTermin);
        } catch (ex) {
          console.error('kalender.component.ts;onEventClick();Fehler im Event-Aufruf', ex);
        }
      }
    }
  }

  loadMitarbeiter() {
    const dataSource: object[] = [];

    if (this.selectedMitarbeiter.length > 0 && this.dbMitarbeiter) {
      for (const mitarbeiter of this.dbMitarbeiter) {
        const index = this.selectedMitarbeiter.indexOf(mitarbeiter.loginname);
        if (index > -1) {
          if (mitarbeiter.calendarHexColor) {
            dataSource.push({
              Mitarbeiter: mitarbeiter.firstname + ' ' + mitarbeiter.lastname, Farbe: mitarbeiter.calendarHexColor, UserName: mitarbeiter.loginname,
            });
          } else {
            dataSource.push({
              Mitarbeiter: mitarbeiter.firstname + ' ' + mitarbeiter.lastname, Farbe: this.pastelTones[Math.floor(Math.random() * this.pastelTones.length)], UserName: mitarbeiter.loginname,
            });
          }
        }
      }
    }

    if (this.scheduleObj) {
      try {
        this.mitarbeiterDataSource = dataSource;
        // Die Resourcen auf die Mitarbeiter dürfen erst zugeordnet werden, wenn diese auch existieren
        this.group = {
          resources: ['Mitarbeiter'],
        };
      } catch (ex) {
        console.error('Fehler beim Laden der Mitarbeiter.', ex);
      }
    }
  }

  loadPendenzen() {
    // Pendenzen Live vom Webservice holen
    this.svcMainData.getEmployeesKalender().subscribe({
      next: (res) => {
        this.kalenderData = res;
        this.loadTermine();
        this.savePendenzen(res);
      }, error: () => {
        // Webservice nicht verfügbar --> aus IndexedDB laden
        this.loadPendenzenFromIndexedDB();
      },
    });
  }

  loadTermine() {
    const dataSource: object[] = [];
    let index = -1;

    if (this.kalenderData && this.kalenderData.termine) {
      for (const pendenz of this.kalenderData.termine) {
        // Prüfen, ob mit Terminserien gearbeitet wird
        if (this.kalenderData.terminSerien) {
          // Prüfen, ob es eine Terminserie ist
          index = this.kalenderData.terminSerien.findIndex((ts) => ts.calendarId === pendenz.id);
        }

        if (index === -1) {
          // Es ist kein Serien-Termin
          const startTime = this._datumFormatPipe.transform(pendenz.startDate, 'yyyy-MM-ddT') + pendenz.startTime + ':00';
          const endTime = this._datumFormatPipe.transform(pendenz.endDate, 'yyyy-MM-ddT') + pendenz.endTime + ':00';
          dataSource.push({
            Id: pendenz.id, Subject: pendenz.description, StartTime: startTime, EndTime: endTime, IsAllDay: false, Notes: pendenz.notes, UserName: pendenz.username,
          });
        } else {
          // Es ist ein Serien-Termin
          const terminSerie = this.kalenderData.terminSerien[index];

          // Gibt es auch Ausnehmen zur Serie?
          let terminSerieAusnahme: MainDataModels.TerminSerieAusnahme[] = [];
          if (this.kalenderData.terminSerieAusnahmen) {
            terminSerieAusnahme = this.kalenderData.terminSerieAusnahmen.filter((x) => x.calendarID === pendenz.id);
          }

          const today = new Date();
          today.setDate(today.getDate() - 60); // letzte 60 Tage
          if (terminSerie.endDate) {
            const compareDate = new Date(terminSerie.endDate);
            // Nur Serien berücksichtigen, die noch gültig sind
            if (compareDate > today) {
              const rule: string = this.svcMainData.getRecurrenceRule(pendenz, terminSerie);
              let recurrenceDates: number[];
              if (terminSerie.startDate) {
                // Converting UTC to UTC +1 date time
                const start = this.timezone.add(new Date(terminSerie.startDate), 'Europe/Zurich');
                // Das viewDate wird benötigt, damit auch der 1. Termin einer Serie immer angezeigt wird.
                const viewDate = new Date(start.getFullYear(), start.getMonth(), start.getDate());

                /* Termin-Serie Ausnahmen berücksichtigen */
                let ausnahmen: any = undefined;
                if (terminSerieAusnahme.length > 0) {
                  ausnahmen = '';
                  for (const ausnahme of terminSerieAusnahme) {
                    // Type = 0 => verschobene Termine aus einer Serie
                    //             (der verschobene Termin ist wieder ein normaler Termin der angezeigt wird)
                    // Type = 1 => gelöschte Termine aus einer Serie
                    if (ausnahme.type === 0 || ausnahme.type === 1) {
                      ausnahmen += this._datumFormatPipe.getSyncfusionCalendarDateStr(new Date(ausnahme.originalDate)) + ',';
                    }
                  }
                  if (ausnahmen.length > 0) {
                    ausnahmen = ausnahmen.substring(0, ausnahmen.length - 1);
                  } // Letztes Komma entfernen
                }

                recurrenceDates = this.recurrenceEditor.getRecurrenceDates(start, rule, ausnahmen, undefined, viewDate);
                if (recurrenceDates && recurrenceDates.length > 0) {
                  for (const value of recurrenceDates) {
                    if (this.swissSettings.getWebConfig().debugMode) {
                      console.log('Datum: ' + new Date(value).toString());
                    }
                    const startTime = this._datumFormatPipe.transform(value, 'yyyy-MM-ddT') + pendenz.startTime + ':00';
                    const endTime = this._datumFormatPipe.transform(value, 'yyyy-MM-ddT') + pendenz.endTime + ':00';
                    dataSource.push({
                      Id: pendenz.id, Subject: pendenz.description, StartTime: startTime, EndTime: endTime, IsAllDay: false, Notes: pendenz.notes, UserName: pendenz.username,
                    });
                  }
                } else {
                  console.error('Fehler bei der Ermittlung der Termin-Serie Daten', pendenz, terminSerie, rule);
                }
              }
            }
          }
          if (this.swissSettings.getWebConfig().debugMode) {
            console.log('Termin-Serie gefunden', pendenz, terminSerie);
          }
        }
      }
    }

    if (this.scheduleObj) {
      try {
        this.myDataSource = dataSource;
        this.flag = true;

        this.scheduleObj!.eventSettings.dataSource = [];
        // this.scheduleObj!.refreshEvents(); 01.04.2022/TH: Diese Zeile gibt manchmal Fehler aus
        this.scheduleObj!.refresh();
        this.scheduleObj!.eventSettings.dataSource = this.myDataSource;
      } catch (ex) {
        console.error('Fehler beim Laden der Pendenzen.', ex);
      }
    }
  }

  async savePendenzen(res: any) {
    await this.localStorageService.add('kalender', res, this.storageWebMain);
  }

  async loadPendenzenFromIndexedDB(): Promise<boolean> {
    return this.localStorageService
      .get('kalender', this.storageWebMain)
      .then((value) => {
        if (value === false) {
          // Es konnte keinen Wert in der indexeddb für Objekte/Aufträge ermittelt werden
          return false;
        } else {
          // Die Aufträge konnten geladen werden
          if (value) {
            this.kalenderData = (value as MainDataModels.KalenderDaten);
            this.loadTermine();
          }
          return true;
        }
      });
  }

  onNewTermin() {
    this.InitNeuerTermin();
    const dialogRef = this.dialog.open(TerminEintragComponent, {
      disableClose: true, width: '800px', data: this.dataForCalendarAppointment,
    });

    this.svcMainData.reloadCalendarData();

    return dialogRef.afterClosed().subscribe({
      next: (result) => {
        if (result) {
          this.currTerminMitBenutzern = result;
          if (this.swissSettings.getWebConfig().debugMode) {
            console.log('Termin vor Speicherung', this.currTerminMitBenutzern);
          }
          if (this.currTerminMitBenutzern) {
            if (this.currTerminMitBenutzern!.mitarbeiter.length > 1) {
              this.currTerminMitBenutzern.termin.groupID = uuidv4();
            }
            // Neuer Termin wird gespeichert oder bestehender Termin aktualisiert
            this.svcMainData.saveTermin(this.currTerminMitBenutzern).subscribe({
              next: () => {
                this.svcMessageBox.showSuccess('Der Termin wurde erfolgreich gespeichert.', 'Erfolgreich');
                this.svcMainData.reloadCalendarData();
              }, error: (error) => {
                console.log(error);
                this.svcMessageBox.showError('Der Termin konnte nicht gespeichert werden!!', '!! FEHLER !!');
              },
            });
          }
        }
      },
    });
  }

  onEditTermin() {
    if (this.currTermin) {
      this.svcMainData.loadTermin().subscribe({
        next: (res) => {
          this.currTerminMitBenutzern = res;

          this.dataForCalendarAppointment = this.currTerminMitBenutzern;

          const dialogRef = this.dialog.open(TerminEintragComponent, {
            disableClose: true, width: '800px', // height: 'auto',
            data: this.dataForCalendarAppointment,
          });

          dialogRef.afterClosed().subscribe({
            next: (result) => {
              this.currTerminMitBenutzern = result;
              if (this.currTerminMitBenutzern) {
                // Update Informations
                this.svcMainData
                  .saveTermin(this.currTerminMitBenutzern)
                  .subscribe({
                    next: () => {
                      this.svcMessageBox.showSuccess('Der Termin wurde erfolgreich aktualisiert.', 'Erfolgreich');
                      this.svcMainData.reloadCalendarData();
                    }, error: (error) => {
                      console.log(error);
                      this.svcMessageBox.showError('Der Termin konnte nicht angepasst werden!!', '!! FEHLER !!');
                    },
                  });
                if (this.swissSettings.getWebConfig().debugMode) {
                  console.log('Dialog Resultat (currTerminMitBenutzern): ', this.currTerminMitBenutzern);
                }
              }
            },
          });
        },
      });
    }
  }

  // Termin wurde verschoben
  moveTermin() {
    this.svcMainData.moveTermin(this.terminAfter!).then((res) => {
      if (res) {
        // Nichts mehr zu machen, da die Termine nur via Webservice geladen werden.
      } else {
        this.svcMessageBox.showError('⚠️ ❗❗ Der Termin konnte nicht verschoben werden!! ❗❗ ⚠️ ', '!! FEHLER !!');
        this.loadPendenzen();
      }
    });
  }

  updateTermin() {
    // Prüfen, ob es ein Gruppentermin ist
    this.svcMainData.getTerminByID(this.terminAfter!.Id).subscribe({
      next: (termin) => {
        if (termin.groupID) {
          this.svcMessageBox
              .askYesNoQuestion('MAIN_APP_DIALOG.MOVE_GROUP_APPOINTMENT.msg', 'MAIN_APP_DIALOG.MOVE_GROUP_APOINTMENT.title')
            .then((value) => {
              if (value) {
                this.moveTermin();
              } else {
                this.loadPendenzen();
              } // Änderung nicht akzeptiert => Pendenzen/Termine neu laden
            });
        } else {
          this.moveTermin();
        }
      },
    });
  }

  private InitNeuerTermin() {
    this.dataForCalendarAppointment = {
      termin: {
        id: uuidv4(), objectID: '', adressID: undefined, description: '', username: this.userAuthService.getCurrentAuthenticatedUser()!.loginname, location: '', private: 0, reminder: 1, reminderNumber: 15, notes: '', busyStatus: 2,
      }, mitarbeiter: [], terminKategorien: [], istNeuerTermin: true, nurDiesenTerminBearbeiten: false,
    };

    // Wenn keine Zelle markiert ist, darf kein Termin-Zeitraum vorbelegt werden.
    const terminScheduler = this.scheduleObj;
    if (terminScheduler?.activeCellsData?.element) {
      const startTermin = terminScheduler.activeCellsData.startTime;
      if (startTermin) {
        this.dataForCalendarAppointment!.termin.startDate = new Date(this._datumFormatPipe.transform(startTermin, 'yyyy-MM-ddT') + '00:00:00');
        this.dataForCalendarAppointment!.termin.startTime = this._datumFormatPipe.transformOnlyTime(startTermin);
      }
      const endTermin = terminScheduler.activeCellsData.endTime;
      if (endTermin) {
        this.dataForCalendarAppointment!.termin.endDate = new Date(this._datumFormatPipe.transform(endTermin, 'yyyy-MM-ddT') + '00:00:00');
        this.dataForCalendarAppointment!.termin.endTime = this._datumFormatPipe.transformOnlyTime(endTermin);
      }
    }
  }
}
